<div class="force-password-modal">
  <header class="force-password-modal__header">
    <h2 class="force-password-modal__title">
      {{ "auth.force-password-change.title" | translate }}
    </h2>
    <p class="force-password-modal__description">
      {{ "auth.force-password-change.description" | translate }}
    </p>
  </header>

  <form
    class="nolia-form"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    novalidate
  >
    <!-- Contraseña actual -->
    <div class="nolia-field">
      <label for="fpc-current-password" class="nolia-field__label">
        {{ "auth.force-password-change.current-password" | translate }}
      </label>
      <div
        class="nolia-input"
        [class.nolia-input--invalid]="formErrors?.['currentPassword']?.label || backendErrors['currentPassword']"
      >
        <img src="assets/v3/shared/icon-lock.svg" alt="" class="nolia-input__icon" aria-hidden="true" />
        <input
          id="fpc-current-password"
          class="nolia-input__field"
          [type]="showCurrentPassword ? 'text' : 'password'"
          formControlName="currentPassword"
          [attr.placeholder]="'auth.force-password-change.current-password-placeholder' | translate"
          autocomplete="current-password"
        />
        <button
          type="button"
          class="nolia-input__toggle"
          (click)="showCurrentPassword = !showCurrentPassword"
          tabindex="-1"
          [attr.aria-label]="
            (showCurrentPassword
              ? 'auth.signin-page.hide-password'
              : 'auth.signin-page.show-password'
            ) | translate
          "
        >
          <img src="assets/v3/shared/icon-eye.svg" alt="" aria-hidden="true" />
        </button>
      </div>
      <p
        class="nolia-field__error"
        *ngIf="formErrors?.['currentPassword']?.label || backendErrors['currentPassword']"
      >
        {{ formErrors?.['currentPassword']?.label || backendErrors['currentPassword'] }}
      </p>
    </div>

    <!-- Contraseña nueva -->
    <div class="nolia-field">
      <label for="fpc-new-password" class="nolia-field__label">
        {{ "auth.force-password-change.new-password" | translate }}
      </label>
      <div
        class="nolia-input"
        [class.nolia-input--invalid]="formErrors?.['newPassword']?.label || backendErrors['newPassword']"
      >
        <img src="assets/v3/shared/icon-lock.svg" alt="" class="nolia-input__icon" aria-hidden="true" />
        <input
          id="fpc-new-password"
          class="nolia-input__field"
          [type]="showNewPassword ? 'text' : 'password'"
          formControlName="newPassword"
          [attr.placeholder]="'auth.force-password-change.new-password-placeholder' | translate"
          autocomplete="new-password"
        />
        <button
          type="button"
          class="nolia-input__toggle"
          (click)="showNewPassword = !showNewPassword"
          tabindex="-1"
          [attr.aria-label]="
            (showNewPassword
              ? 'auth.signin-page.hide-password'
              : 'auth.signin-page.show-password'
            ) | translate
          "
        >
          <img src="assets/v3/shared/icon-eye.svg" alt="" aria-hidden="true" />
        </button>
      </div>
      <p
        class="nolia-field__error"
        *ngIf="formErrors?.['newPassword']?.label || backendErrors['newPassword']"
      >
        {{ formErrors?.['newPassword']?.label || backendErrors['newPassword'] }}
      </p>
    </div>

    <!-- Repetir contraseña nueva -->
    <div class="nolia-field">
      <label for="fpc-confirm-password" class="nolia-field__label">
        {{ "auth.force-password-change.confirm-password" | translate }}
      </label>
      <div
        class="nolia-input"
        [class.nolia-input--invalid]="
          formErrors?.['newPassword2']?.label
          || (form.hasError('notSame') && confirmPasswordWatched)
          || backendErrors['newPassword2']
        "
      >
        <img src="assets/v3/shared/icon-lock.svg" alt="" class="nolia-input__icon" aria-hidden="true" />
        <input
          id="fpc-confirm-password"
          class="nolia-input__field"
          [type]="showConfirmPassword ? 'text' : 'password'"
          formControlName="newPassword2"
          [attr.placeholder]="'auth.force-password-change.confirm-password-placeholder' | translate"
          autocomplete="new-password"
        />
        <button
          type="button"
          class="nolia-input__toggle"
          (click)="showConfirmPassword = !showConfirmPassword"
          tabindex="-1"
          [attr.aria-label]="
            (showConfirmPassword
              ? 'auth.signin-page.hide-password'
              : 'auth.signin-page.show-password'
            ) | translate
          "
        >
          <img src="assets/v3/shared/icon-eye.svg" alt="" aria-hidden="true" />
        </button>
      </div>
      <p
        class="nolia-field__error"
        *ngIf="
          formErrors?.['newPassword2']?.label
          || (form.hasError('notSame') && confirmPasswordWatched)
          || backendErrors['newPassword2']
        "
      >
        {{
          formErrors?.['newPassword2']?.label
            || (form.hasError('notSame') && confirmPasswordWatched ? ('auth.force-password-change.not-match' | translate) : '')
            || backendErrors['newPassword2']
        }}
      </p>
    </div>

    <button
      type="submit"
      class="nolia-btn nolia-btn--primary"
      [disabled]="
        isLoading
        || newPasswordWatched.length < 4
        || confirmPasswordWatched.length < 4
        || newPasswordWatched !== confirmPasswordWatched
      "
    >
      {{
        (isLoading
          ? "auth.force-password-change.updating-button"
          : "auth.force-password-change.update-button"
        ) | translate
      }}
    </button>
  </form>
</div>
